import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.ManagementFee.Title',
    defaultMessage: 'MANAGEMENT ADD-ON FEES',
  },
  titleTooltip: {
    id: 'App.ViewProperty.AffordableSetup.ManagementFee.Title.Tooltip',
    defaultMessage:
      'When enabled, each management add-on fee automatically adds ' +
      '$5 per unit per month to the management fee in the budget.',
  },
  nonContinuousParcelsLabel: {
    id: 'App.ViewProperty.AffordableSetup.ManagementFee.NonContinuousParcels.Label',
    defaultMessage: 'Non-continuous parcels of lands',
  },
  propertiesInRemoteLabel: {
    id: 'App.ViewProperty.AffordableSetup.ManagementFee.PropertiesInRemote.Label',
    defaultMessage: 'Properties in a remote location',
  },
  troubledOrCriticalLabel: {
    id: 'App.ViewProperty.AffordableSetup.ManagementFee.TroubledOrCritical.Label',
    defaultMessage: 'Troubled or Critical Property',
  },
  troubledOrCriticalTooltip: {
    id: 'App.ViewProperty.AffordableSetup.ManagementFee.TroubledOrCritical.Tooltip',
    defaultMessage:
      'Troubled or critical properties with workout plans and ' +
      'new management only.',
  },
});
